<template>
    <v-row>
        <v-col>
            <v-checkbox v-model="multiselect" label="Multi-select" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, allows the user to select multiple values.</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="allowModifiers" label="Allow modifiers" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, a selected value can have free text entered with it.</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="loadLocal" label="Load all values" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, the control will get all values on page load and show cached values, otherwise will make requests as you type.</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="sortByValue" label="Sort values" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, the values will be sorted client-side (alphabetically descending).</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="allowUserSupplied" label="Allow user-supplied values" @change="emit"/>
            <span class="body-2 text--secondary">Whether to allow user-supplied values to be used. Any suppied values will be saved in the browser session.</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="selectSingle" label="Select single option" @change="emit"/>
            <span class="body-2 text--secondary">If enabled and there is only one option, selects that one option.</span>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'AutoComplete',
        data: () => ({
            multiselect: false,
            allowModifiers: false,
            loadLocal: false,
            sortByValue: false,
            allowUserSupplied: false,
            selectSingle: false
        }),
        methods: {
            emit() {
                let opts = {
                        type: 'autocomplete', 
                        multiSelect: this.multiselect, 
                        allowModifiers: this.allowModifiers, 
                        loadLocal: this.loadLocal, 
                        sortByValue: this.sortByValue, 
                        allowUserSupplied: this.allowUserSupplied,
                        autoSelectSingleValue: this.selectSingle
                };

                this.$emit('change', opts);
            }
        },
        created() {
            this.emit();
        }
    }
</script>
